import { render, staticRenderFns } from "./goodsShareList.vue?vue&type=template&id=6fdfcf72&scoped=true&"
import script from "./goodsShareList.vue?vue&type=script&lang=js&"
export * from "./goodsShareList.vue?vue&type=script&lang=js&"
import style0 from "./goodsShareList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./goodsShareList.vue?vue&type=style&index=1&id=6fdfcf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfcf72",
  null
  
)

component.options.__file = "goodsShareList.vue"
export default component.exports